<template>
  <div class="componentBox">
    <h2 class="componentTitle">打样/收获信息</h2>
    <h3 class="littleTitle">打样/收获概况</h3>
    <p style="margin-left: 20px;">打样次数(次)：{{ proofingHarvestInfoDetailDTOList.length }}</p>
    <Table style="padding: 0 20px;" :columns="proofingInfoCol" :list="proofingInfoList" />
    <h3 class="littleTitle" style="margin-top: 20px;">打样/收获明细</h3>
    <Tabs style="padding: 0 20px;" :columns="proofingCol" :list="proofingHarvestInfoDetailDTOList" />
    
    <h3 class="littleTitle" style="margin-top: 20px;">死鱼信息(吃食性)</h3>
    <Tabs style="padding: 0 20px;" :columns="dieCol" :list="dieInfoDetailDTOList" :alert="true" />
    <h3 class="littleTitle" style="margin-top: 20px;">阶段/全程生产成绩</h3>
    <Cell :colList="list" :detail="detail.productResult || {}"/>
  </div>
</template>

<script>
import Table from './Table.vue';
import Cell from './Cell.vue';
import Tabs from './Tabs.vue'
export default {
  components: {Tabs,Cell,Table},
  props: ['detail'],
  data() {
    return {
      numbers: ['零','一','二','三','四','五','六','七','八','九',],
      proofingInfoCol: [
        {
          title: '品种类型',
          dataIndex: 'varietyType',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '品种数(个)',
          dataIndex: 'varietyNum',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '数量(尾)',
          dataIndex: 'num',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '重量(斤)',
          dataIndex: 'weight',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
      ],
      proofingCol: [
        {
          title: '时间',
          dataIndex: 'date',
          width: 140,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '品种',
          dataIndex: 'varietyName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '类型',
          dataIndex: 'varietyLabelName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '数量(尾)',
          dataIndex: 'proofingHarvestNum',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '重量(斤)',
          dataIndex: 'proofingHarvestWeight',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
      ],
      dieCol: [
        {
          title: '品种',
          dataIndex: 'varietyName',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '数量(尾)',
          dataIndex: 'dieNum',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
        {
          title: '重量(斤)',
          dataIndex: 'dieWeight',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'fixed' },
        },
      ],
      list: [
        {title: '总成活率(%)',field: 'totalSurvivalRate',},
        {title: '吃食鱼成活率',field: 'eatFoodSurvivalRate',},
        {title: '饵料系数',field: 'baitFactor',},
        {title: '总产量(斤/亩)',field: 'totalOutput',},
        {title: '吃食鱼产量(斤/亩)',field: 'eatFoodOutput',},
        {title: '滤食鱼产量(斤/亩)',field: 'filterFoodOutput',},
        {title: '饲料产量(斤/吨)',field: 'feedOutput',},
        {title: '造肉成本(元/斤)',field: 'meatProductCost',},
      ],
    }
  },
  watch: {},
  computed: {
    proofingInfoList(){
      let lst = []
      let {proofingHarvestInfo={}} = this.detail || {}
      let fieldArr = [
        {name: '吃食鱼',field: 'eatFood'},
        {name: '滤食鱼',field: 'filterFood'},
        {name: '总计',field: 'total'},
      ]
      lst = fieldArr.map(el => {
        return {
          varietyType: el.name,
          varietyNum: proofingHarvestInfo[`${el.field}ProofingHarvestVarietyNum`],
          num: proofingHarvestInfo[`${el.field}ProofingHarvestNum`],
          weight: proofingHarvestInfo[`${el.field}ProofingHarvestWeight`],
        }
      })
      return lst
    },
    proofingHarvestInfoDetailDTOList(){
      let {proofingHarvestInfoDetailDTOList=[]} = this.detail || {}
      proofingHarvestInfoDetailDTOList = proofingHarvestInfoDetailDTOList.map((el,i) => {
        let cs = el.details.filter(el => el.varietyLabelCode === 'chishi') || []
        let ls = el.details.filter(el => el.varietyLabelCode === 'lvshi') || []
        let csNum = 0,
        lsNum = 0,
        csWeight = 0,
        lsWeight = 0
        cs.forEach(el => {
          csNum += Number(el.proofingHarvestNum || 0)
          csWeight += Number(el.proofingHarvestWeight || 0)
        })
        ls.forEach(el => {
          lsNum += Number(el.proofingHarvestNum || 0)
          lsWeight += Number(el.proofingHarvestWeight || 0)
        })
        csWeight = csWeight.toFixed(this.len)
        lsWeight = lsWeight.toFixed(this.len)
        let proofingHarvestNum = 0,proofingHarvestWeight = 0
        el.details.map(item => {
          proofingHarvestNum += Number(item.proofingHarvestNum || 0)
          proofingHarvestWeight += Number(item.proofingHarvestWeight || 0)
          item.date = el.proofingHarvestDate
          return item
        })
        el.title = `第${this.numbers[i+1]}次`
        el.csNum = csNum
        el.lsNum = lsNum
        el.csWeight = csWeight
        el.lsWeight = lsWeight
        el.details.push(
          {
            date: '总计',
            proofingHarvestNum: Number(proofingHarvestNum).toFixed(this.len),
            proofingHarvestWeight: Number(proofingHarvestWeight).toFixed(this.len),
          }
        )
        return el
      })
      return proofingHarvestInfoDetailDTOList
    },
    dieInfoDetailDTOList(){
      let {dieInfoDetailDTOList=[]} = this.detail || {}
      dieInfoDetailDTOList = dieInfoDetailDTOList.map((el,i) => {
        let dieNum = 0,dieWeight = 0
        el.details.map(item => {
          dieNum += Number(item.dieNum || 0)
          dieWeight += Number(item.dieWeight || 0)
          item.date = el.proofingHarvestDate
          return item
        })
        el.title = `第${this.numbers[i+1]}次`
        el.details.push(
          {
            varietyName: '总计',
            dieNum: Number(dieNum).toFixed(this.len),
            dieWeight: Number(dieWeight).toFixed(this.len),
          }
        )
        return el
      })
      return dieInfoDetailDTOList
    },
  },
  created() {},
  mounted() {
    this.staffId=window.localStorage.getItem('staffId')
  },
  methods: {
    productDetail(record){
      this.$router.push({
        path: '/nhf-compound-editor',
        query: {
          id: record.nhfFormulaId
        }
      })
    }
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>